<template>
  <div>
    <div v-for="(day, d) in days" :key="'days' + d" class="grid">
      <div class="cell">{{ day.date }}</div>
      <div>
        <div v-for="(work, w) in day.work_types" :key="'day.work_types' + w">
          <div v-for="(report, r) in work.reports" :key="'day.work_types.report' + r">
            <StatisticProjectReportsBlankExcelTableByDaysItem
              :work="work"
              :report="report"
              :on-update="onUpdate"
              :employee_id="data.employee_id"
            />
          </div>
        </div>
        <div v-if="day.extras">
          <div class="grid_inner fw500">
            <div class="cell" :class="day['extras_signed'] ? 'secondary lighten-5 secondary--text text-darken-2' : ''">
              <BaseCheckbox
                v-model="day['extras_approved']"
                class="mr-2"
                @input="changeExtra(d, false)"
                :disabled="day['extras_signed']"
              />
              {{ $formatTime(getReportsSumByField(day.extras, 'employee_report')) }}
            </div>
            <div class="cell">
              <template v-if="day['extras_approved'] !== false">
                {{ $formatTime(getReportsSumByField(day.extras, 'approved_report')) }}
              </template>
            </div>
            <div class="cell one_col">{{ localStorage.translations.pages.finance['period-table']['total-extra'] }}</div>

          </div>
          <div v-for="(extra, e) in day.extras" :key="'day.extra' + e">
            <div v-for="(report, r) in extra.reports" :key="'day.extra.report' + r">
              <StatisticProjectReportsBlankExcelTableByDaysItem
                :work="extra"
                :report="report"
                is-extra
                :on-update="onUpdate"
                :employee_id="data.employee_id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCheckbox from "../../../../base/BaseCheckbox";
import StatisticProjectReportsBlankExcelTableByDaysItem from "./StatisticProjectReportsBlankExcelTableByDaysItem";

export default {
  name: "StatisticProjectReportsBlankExcelTableByDays",
  components: {StatisticProjectReportsBlankExcelTableByDaysItem, BaseCheckbox},
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    onUpdate: {}
  },
  computed: {
    days() {
      let days = {}
      let arr = ['work_types', 'extras']
      for (let r in arr) {
        let field = arr[r]
        for (const workKey in this.data[field]) {
          const currentWork = this.data[field][workKey]
          for (const dayKey in currentWork.days) {
            let date = dayKey.split('-')
            if (currentWork.days[dayKey].reports) {
              let data = {
                name: currentWork.name,
                measure: currentWork.measure,
                is_hourly: currentWork.is_hourly,
                reports: currentWork.days[dayKey].reports
              }
              if (days[dayKey]) {
                if (!days[dayKey][field]) {
                  days[dayKey][field] = {}
                }
                days[dayKey][field][workKey] = data
              } else {
                days[dayKey] = {}
                days[dayKey][field] = {}
                days[dayKey][field][workKey] = data
              }
              days[dayKey].date = date[2] + '/' + date[1]
              // get value for checkbox from all extras by one day
              if (days[dayKey].extras) {
                let reports = []
                let extras = Object.values(days[dayKey].extras).map(data => data.reports)
                for (let e in extras)
                  for (let r in extras[e])
                    reports.push(extras[e][r])
                let check = {'approved': null, 'paid': null, signed: null}
                for (let field in check) {
                  let signed = field === 'signed'
                  check[field] = reports.map(data => data[signed ? 'client_report_status' : field + '_report'])
                  days[dayKey]['extras_' + field] = check[field].every(cur => {
                    return signed ? cur !== null : Number(cur) > 0
                  })
                    ? true
                    : check[field].every(cur => {
                      return signed ? cur === null : Number(cur) === 0
                    })
                      ? false
                      : null
                }
              }
              
            }
          }
        }
      }
      return Object.keys(days).sort().reduce(
        (accumulator, index) => ({
          ...accumulator,
          [index]: days[index]
        }), {}
      )
    },
  },
  methods: {
    getReportsSumByField(items, field) {
      return Object.values(items)
        .map(data => data.reports)
        .reduce((sum, current) => {
          return sum + current.reduce((sum, current) => {
            return sum + current[field]
          }, 0)
        }, 0)
    },
    
    async changeExtra(day, paid) {
      let field = paid ? 'paid' : 'approved'
      let data = []
      for (let e in this.days[day].extras) {
        let reports = this.days[day].extras[e].reports
        for (let r in reports) {
          let temp = {}
          temp.id = reports[r].id
          temp[field + '_hours'] = this.days[day]['extras_' + field]
            ? reports[r]['paid_report'] || reports[r]['approved_report'] || reports[r]['employee_report']
            : 0
          if (paid) {
            if (reports[r]['client_report_status'] === 'signed') data.push(temp)
          } else if (reports[r]['client_report_status'] === null) data.push(temp)
          temp[field + '_notes'] = this.days[day]['extras_' + field]
            ? reports[r][field + '_notes'] || ''
            : ''
        }
      }
      if (this.onUpdate) this.onUpdate(data, this.days[day]['extras_' + field] > 0, false, true)
    }
  }
}
</script>
